import { Component } from '@angular/core';
import { SemiCircleComponent } from './semi-circle.component';

@Component({
    // tslint:disable-next-line:component-selector
    selector: '[coolingSemiCircle]',
    templateUrl: './semi-circle.component.html',
    styleUrls: ['./semi-circle.component.scss'],
})
export class CoolingSemiCircleComponent extends SemiCircleComponent {

}
